module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-high-b8b1299a.svg";